export const Patterns = Object.freeze({
  OrganisationNumber: /(^([0-9]{6})-([0-9]{4})$)/i,
  PhoneNumber: /^(([+]46)(7)|07)[02369](\d{4})(\d{3})$/i,
});
